// 261010 UI-icons — chip trạng thái dạng biểu tượng + màu (+ số nếu có); chữ gốc ở Tooltip và aria-label. Luật: workflowStatusIcons.ts.
import React from 'react';
import { Tooltip } from 'antd';
import WfIcon from './WfIcon';
import { statusIconOf, type IconName } from './workflowStatusIcons';
import type { StateTone } from './workflowBoardUtils';

interface BaseProps { label: string; icon: IconName; tone: StateTone | string; value?: string | null; testId?: string; className?: string; /** false khi nằm trong nút khác (không thêm điểm dừng Tab). */ focusable?: boolean }

/** Biểu tượng + số, màu theo tông; Tooltip = `label`. Dùng cho mọi chip kiểu icon của bảng. */
export const IconChip: React.FC<BaseProps> = ({ label, icon, tone, value, testId, className, focusable = true }) => (
  <Tooltip title={label}>
    <span className={`wf-si ${tone}${className ? ` ${className}` : ''}`} role="img" aria-label={label} tabIndex={focusable ? 0 : undefined} data-testid={testId}>
      <WfIcon name={icon} />{value ? <span className="n">{value}</span> : null}
    </span>
  </Tooltip>
);

/** Chip trạng thái từ chữ (`stepBadgeOf` / `STATE_META`) + tông. */
const StatusIcon: React.FC<{ text: string; tone: StateTone; testId?: string; className?: string; focusable?: boolean }> = ({ text, tone, testId, className, focusable }) => {
  const v = statusIconOf(text, tone);
  return <IconChip label={v.label} icon={v.icon} tone={v.tone} value={v.value} testId={testId} className={className} focusable={focusable} />;
};

export default StatusIcon;
